import { IPhotoSliderProps } from 'react-photo-view/dist/PhotoSlider';
import { IBroadcastCommandPhotosViewerOption } from '@/interfaces';
import { PhotoSlider } from 'react-photo-view';
import { broadcastService } from '@/services';
import { useEffect, useState } from 'react';
import { filter } from 'rxjs';

interface IState extends IPhotoSliderProps {
}

const CONSTS = {
  initState: {
    bannerVisible: false,
    images: [] as any,
    visible: false
  } as IState
};

const PhotosViewer = () => {

  const [state, setState] = useState<IState>(CONSTS.initState);

  useEffect(
    () => {
      const subscription = (
        broadcastService
          .observable()
          .pipe(filter(l => l.type === 'photosViewer'))
          .subscribe(
            command => {
              const payload = command.payload as IBroadcastCommandPhotosViewerOption;
              setState(l => ({ ...l, ...payload }));
            }
          )
      );

      return () => {
        subscription.unsubscribe();
      };
    },
    []
  );

  return <PhotoSlider {...state} />;

};

export default PhotosViewer;